export default __webpack_public_path__ + "static/media/devtalks.829e3abf.png";